import { render, staticRenderFns } from "./SendgridActivity.vue?vue&type=template&id=2ab5dda7"
import script from "./SendgridActivity.vue?vue&type=script&lang=js"
export * from "./SendgridActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports